import { createRoot } from 'react-dom/client';
import App from './app/App.tsx';
import { requestDesktopExternalUrl } from './features/auth/desktopProxy';
import { getInitialZoom } from './shared/ui/zoom';

const environment = import.meta.env.VITE_APP_ENV;
document.title = environment === "LOCAL" || environment === "DEV"
  ? `nprice console · ${environment}`
  : "nprice console";

function handleEmbeddedExternalLink(event: MouseEvent): void {
  if (event.defaultPrevented || event.button !== 0) {
    return;
  }
  if (typeof window === "undefined" || window.parent === window) {
    return;
  }
  if (!(event.target instanceof Element)) {
    return;
  }

  const link = event.target.closest<HTMLAnchorElement>('a[target="_blank"]');
  if (!link?.href || !requestDesktopExternalUrl(link.href)) {
    return;
  }
  event.preventDefault();
}

document.addEventListener("click", handleEmbeddedExternalLink);

const savedTheme = window.localStorage.getItem("nprice-theme");
document.documentElement.dataset.theme = savedTheme === "dark" || savedTheme === "light"
  ? savedTheme
  : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
document.documentElement.style.setProperty("--app-zoom", String(getInitialZoom()));

const root = createRoot(document.getElementById('root')!)
root.render(<App />);
